import * as router from './js/router.js';
router.init();
